import { render, staticRenderFns } from "./splitDetail.vue?vue&type=template&id=dd23d35a&scoped=true"
import script from "./splitDetail.vue?vue&type=script&lang=js"
export * from "./splitDetail.vue?vue&type=script&lang=js"
import style0 from "./splitDetail.vue?vue&type=style&index=0&id=dd23d35a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd23d35a",
  null
  
)

export default component.exports